module.exports = __webpack_public_path__ + "static/img/error_404.9122023.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/error/images/error_404.png
// module id = Vg7N
// module chunks = 57